export default {
    isAuthenticated(state) {
        return !!state.user;
    },
    email(state) {
        return state.user.email;
    },
    userUid: state => state.user && state.user.uid
}